import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getAll = () => {
    return axios.get(`/api/notification/getall`, { headers: authHeader() })
        .then(res => { return res.data });
}

const getUnRead = () => {
    return axios.get(`/api/notification/getunread`, { headers: authHeader() })
        .then(res => { return res.data });
}

const readById = (id) => {
    return axios.patch(`/api/notification/markasread/${id}`, {}, { headers: authHeader() })
        .then(res => { return res.data });
}

const readByArrayIds = (arrayIds) => {
    return axios.patch(`/api/notification/MarkAsReadAll`, arrayIds, { headers: authHeader() })
        .then(res => { return res.data })
}

export const notificationService = {
    getAll,
    getUnRead,
    readById,
    readByArrayIds
}